import React from 'react';
import styles from './Projects.module.css'; // Make sure you import the correct CSS file
import Card from '../../components/common/Card/Card';
import Footer from '../../components/common/Footer/Footer'
import ClearButton from '../../components/HomePage/ClearButton/ClearButton.js'

const Projects = () => {
  const clearAction = (subject) => {
    const email = 'support@culturehint.com';
    const body = 'Scrivere qui la richiesta di supporto. Il team di Culture Hint risponderà a breve.';
    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };
  return (
    
    <div className={styles.projectsPage}>
      <div className={styles.p}>
        <p>Qui trovi alcuni progetti ed eventi pertinenti per il gruppo CIRCE.</p>
      </div >
      <h2 >
      Assistenza
      </h2>
      <div style={{padding:"0.2rem"}}>
      <div className={styles.buttonCover}>
        <ClearButton text="Prenota incontro con esperto" onClick={() => clearAction('1 to 1 meeting')} />
      </div>
      <div className={styles.buttonCover}>
        <ClearButton text="Richiedi incontro tra pari" onClick={() => clearAction('Peer to peer')} />
      </div></div>
      <h2 >
      Opportunità
      </h2>
      <div className={styles.outerCardContainer}>
      <div className={styles.cardContainer}>
        
        <Card 
        text="Avviso pubblico a supporto delle imprese che operano nei borghi destinatari di finanziamenti PNRR – M1C3|2.1 Attrattività dei borghi" 
        date="Scadenza: 11/09/2023 ore 18:00"
        title="Finanziamento PNRR"
        link="https://pnrr.cultura.gov.it/avviso-pubblico-a-supporto-delle-imprese-che-operano-nei-borghi-destinatari-di-finanziamenti-pnrr-m1c32-1-attrattivita-dei-borghi/"
        type='Finanziamento imprese'
        />
 
      </div>
      <div className={styles.cardContainer}>
        
        <Card 
        text="L’avviso pubblico ha come obiettivo quello di fornire supporto ai settori culturali e creativi attraverso contributi finanziari per realizzare attività, progetti o prodotti volti a contribuire all’azione per il clima, coniugando design e sostenibilità, orientando il pubblico verso comportamenti più responsabili nei confronti della natura e dell’ambiente." 
        date="Scadenza: 12/07/2023 ore 18:00"
        title="Transizione ecologica organismi culturali e creativi"
        link="https://www.invitalia.it/chi-siamo/area-media/notizie-e-comunicati-stampa/avviso-tocc-ecologica"
        type='Finanziamento PNRR'
        
        />
 
      </div>

      <div className={styles.cardContainer}>
        
        <Card 
        text="Il World Travel Market è la fiera mondiale del turismo. Si terrà a Londra dal 6 all'8 Novembre 2023." 
        date="Da 6 a 8/11/2023"
        title="World Travel Market"
        link="https://www.wtm.com/london/en-gb.html"
        type='Fiera del turismo'
        />
 
      </div>

      <div className={styles.cardContainer}>
        
        <Card 
        text="Il TTG è la fiera italiana del turismo. Si terrà a Rimini dall'11 al 13 Ottobre 2023" 
        date="Da 11 a 13/10/2023"
        title="TTG Rimini"
        link="https://www.ttgexpo.it/"
        type='Fiera del turismo'
        />
 
      </div>
      
</div>
      <Footer></Footer>
    </div>
  );
};

export default Projects;